<template>
  <v-container>
    <back-link-component :to="{ name: 'BillingBilling' }" :label="$tt('customBillingMenu')" />
    <h2>{{ $tt('customBillingMethod') }}</h2>
    <v-row justify="center">
      <!-- 登録済みのカード -->
      <v-col md="6" cols="12">
        <credit-card-list-component />
      </v-col>
      <!-- 新しいカードの追加 -->
      <v-col md="6" cols="12">
        <add-credit-card-component />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreditCardListComponent from '@/components/billing/CreditCardListComponent'
import AddCreditCardComponent from '@/components/billing/AddCreditCardComponent'
export default {
  name: 'BillingMethods',
  components: { AddCreditCardComponent, CreditCardListComponent },
  mounted() {
    this.$store.dispatch('getStripeInfo')
  },
}
</script>
